import React from "react";

const ProposalBigIcon = () => {
  return (
    <svg
      width="22"
      height="28"
      viewBox="0 0 22 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.125 0.5H13.625L21.5 8.6V24.8C21.5 25.5161 21.2234 26.2028 20.7312 26.7092C20.2389 27.2155 19.5712 27.5 18.875 27.5H3.125C2.42881 27.5 1.76113 27.2155 1.26884 26.7092C0.776562 26.2028 0.5 25.5161 0.5 24.8V3.2C0.5 2.48392 0.776562 1.79716 1.26884 1.29081C1.76113 0.784463 2.42881 0.5 3.125 0.5ZM12.3125 3.19998V9.94998H18.875L12.3125 3.19998Z"
        fill="#30323A"
      />
    </svg>
  );
};

export default ProposalBigIcon;
